import React from 'react';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import { User } from '@spa-cars/models';
import { CURRENT_USER } from '../graphql/queries';
import Loading from '../components/shared/Loading';

export type TUserContext = {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
};

export const UserContext = React.createContext<TUserContext>({
  user: null,
  setUser: () => {},
});

interface UserContextProviderProps {
  children: React.ReactNode;
}

export function UserContextProvider({ children }: UserContextProviderProps) {
  const router = useRouter();

  const [user, setUser] = React.useState<User | null>(null);

  const {
    loading: loadingUser,
    data: dataUser,
    error: errorUser,
  } = useQuery<{
    currentUser: { user: User };
  }>(CURRENT_USER);

  React.useEffect(() => {
    if (!loadingUser) {
      if (dataUser?.currentUser?.user) {
        setUser(dataUser.currentUser?.user);
      } else if (errorUser || !dataUser?.currentUser?.user) {
        setUser(null);
        if (!router?.asPath?.includes('reset-password')) {
          router?.push('/');
        }
      }
    }
  }, [dataUser, errorUser, loadingUser]);

  const context = React.useMemo(() => ({ user, setUser }), [user, setUser]);
  return (
    <UserContext.Provider value={context}>
      {loadingUser ? <Loading /> : children}
    </UserContext.Provider>
  );
}
